import { render, staticRenderFns } from "./ChartLossesPerProduk.vue?vue&type=template&id=9987fc34"
import script from "./ChartLossesPerProduk.vue?vue&type=script&lang=js"
export * from "./ChartLossesPerProduk.vue?vue&type=script&lang=js"
import style0 from "./ChartLossesPerProduk.vue?vue&type=style&index=0&id=9987fc34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports